import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=e5ec58d4&scoped=true"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=e5ec58d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec58d4",
  null
  
)

export default component.exports